const option = [
    { id: '1', name: 'เงินสด' },
    { id: '2', name: 'บัตรเครดิต' },
    { id: '3', name: 'โอนเงิน' },
    { id: '4', name: 'จ่ายเช็ค' },
]

const method = {
    getValueByKey(id) {
        return option.find(x => x.id === id).name;
    }
}

export default {
    option: option,
    service: method
};